define.alias("shared/components/shared/schedule-navbar/notification", "settings/components/shared/schedule-navbar/notification");